import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { expenseActions, themeActions } from "../../store/index";
import DownloadCSV from "./DownloadCSV";
import "./Expense.css";
import Button from "../UI/Button";

const Expense = () => {
    const isToken = localStorage.getItem("token");
    let username = localStorage.getItem("email");

    const [expenses, setExpenses] = useState([]);
    const [expense, setExpense] = useState("");
    const [desc, setDesc] = useState("");
    const [category, setCategory] = useState("");
    const [total, setTotal] = useState(0);

    const dispatch = useDispatch();

    let t = "";
    for (let i = 0; i < username.length; i++) {
        if (username[i] === '.' || username[i] === '@') {
            continue;
        }
        else {
            t += username[i];
        }
    }
    username = t;

    useEffect(() => {
        let data_obj = [];
        let total_local = 0;
        fetch(`https://expensetracker-16e15-default-rtdb.firebaseio.com/expenses/${username}.json`)
            .then((res) => {
                if (res.ok) {
                    return res.json();
                }
            }).then((data) => {
                for (let [key, value] of Object.entries(data)) {
                    data_obj.push({ key, ...value })
                }
                for (let i = 0; i < data_obj.length; i++) {
                    total_local = total_local + (+data_obj[i].expense);
                }
                setExpenses([...data_obj]);
                setTotal(total_local);
            })
            .catch((err) => {
                console.error(err);
            })
    });

    const submitHandler = (e) => {
        e.preventDefault();
        const test = {
            expense: expense,
            description: desc,
            category: category,
        }
        fetch(`https://expensetracker-16e15-default-rtdb.firebaseio.com/expenses/${username}.json`, {
            method: "POST",
            body: JSON.stringify(test),
            headers: {
                "Content-Type": "application/json",
            }
        }).then((res) => {
            if (res.ok) {
                return res.json();
            }
            else {
                return res.json().then((data) => {
                    throw new Error(data.error.message);
                })
            }
        }).then((data) => {
            window.location.reload();
            dispatch(expenseActions.addExpenses({
                expense: expense,
                description: desc,
                category: category,
                key: data.name,
            }));
            dispatch(expenseActions.getTotal(total));
        }).catch((err) => {
            console.error(err);
        });
    }

    const deleteHandler = (id) => {
        fetch(`https://expensetracker-16e15-default-rtdb.firebaseio.com/expenses/${username}/${id}.json`, {
            method: "DELETE",
        }).then((res) => {
            if (res.ok) {
                return res.json();
            }
            else {
                return res.json().then((data) => {
                    throw new Error(data.error.message);
                })
            }
        }).then((data) => {
            window.location.reload();
            dispatch(expenseActions.removeExpenses(id));
        }).catch((err) => {
            console.log(err.message);
        })
    }

    const editHandler = (id) => {
        const toEdit = (expenses.find((expense) => expense.key === id));
        setExpense(toEdit.expense);
        setDesc(toEdit.description);
        setCategory(toEdit.category);
        fetch(`https://expensetracker-16e15-default-rtdb.firebaseio.com/expenses/${username}/${id}.json`, {
            method: "DELETE"
        }).then((res) => {
            if (res.ok) {
                return res.json();
            }
            else {
                return res.json().then((data) => {
                    throw new Error(data.error.message);
                })
            }
        }).then((data) => {
            console.log(data);
        }).catch((err) => {
            console.log(err.message);
        })
    }

    const premiumHandler = (e) => {
        e.preventDefault();
        dispatch(themeActions.activateTheme());
    }
    return (
        <React.Fragment>
            {isToken && <div className="expense">
                <form onSubmit={submitHandler}>
                    <label htmlFor="expense">Expense:</label>
                    <input type="number" id="expense" placeholder="Enter expense" value={expense} onChange={(e) => setExpense(e.target.value)} required />
                    <label htmlFor="desc">Description:</label>
                    <input type="text" id="desc" placeholder="Enter description" value={desc} onChange={(e) => setDesc(e.target.value)} required />
                    <label htmlFor="category">Category</label>
                    <select name="category" id="category" value={category} onChange={(e) => setCategory(e.target.value)}
                        required>
                        <option value="">Select an Option</option>
                        <option value="food">Food</option>
                        <option value="Petrol">Petrol</option>
                        <option value="Medical">Medical</option>
                        <option value="Others">Others</option>
                    </select>
                    <Button className="btn-primary mb">Add Expense</Button>
                </form>
            </div>}
            <div className="premium">
                {total > 10000 && <Button className="btn-primary mb ml" onClick={premiumHandler}>Activate Premium</Button>}
                {<DownloadCSV data={expenses} />}
            </div>
            {isToken && <div id="expense-list">
                <ul className="expense-item">
                    <li className="expense-amount"><h4>Expense</h4></li>
                    <li className="expense-desc"><h4>Description</h4></li>
                    <li className="expense-category"><h4>Category</h4></li>
                    <li className="expense-edit"><h4>Edit</h4></li>
                    <li className="expense-delete"><h4>Delete</h4></li>
                </ul>
                {expenses.map((expense) => {
                    return (<ul key={Math.random() * 10} className="expense-item">
                        <li className="expense-amount">{expense.expense}</li>
                        <li className="expense-desc">{expense.description}</li>
                        <li className="expense-category">{expense.category}</li>
                        <Button className="expense-edit" onClick={editHandler.bind(null, expense.key)}>Edit</Button>
                        <Button className="expense-delete" onClick={deleteHandler.bind(null, expense.key)}>Delete</Button>
                    </ul>)
                })}
            </div>}
        </React.Fragment>)
}

export default Expense;